import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, Switch, Route, Redirect } from "react-router-dom";

import { CPage, CTab, CButton, CFontIcon } from "@appcues/component-library";
import authClient from "authClient";
import { selectAccountFeature } from "reducers/account/features";

import IndexPage from "components/Common/IndexPage";
import Installation from "components/Installation";
import Team from "components/Team";
import Subscription from "components/Subscription";
import AccountPage from "components/AccountPage";
import IntegrationsPage from "components/IntegrationsPage";
import PropertiesAndEvents from "components/PropertiesAndEvents";
import Localization from "components/Settings/Localization";

import { reportError } from "helpers/error-reporting";
import { FLOW_LOCALIZATION } from "constants/features";
import { logoutUserFromChromeExtension } from "actions/chromeExtension";

export class Settings extends Component {
  static propTypes = {
    hasFlowLocalization: PropTypes.bool,
    logoutUserFromChromeExtension: PropTypes.func
  };

  handleClickLogout = () => {
    this.props.logoutUserFromChromeExtension();
    authClient.logoutUser({ reportError });
  };

  render() {
    const { hasFlowLocalization } = this.props;

    return (
      <IndexPage
        title="Settings"
        subHeaderActions={
          <CButton onClick={this.handleClickLogout}>
            <CFontIcon className="fas fa-sign-out-alt" />
            Sign out
          </CButton>
        }
      >
        <CPage.SecondBar>
          <CTab.Bar>
            <CTab is={NavLink} to="/settings/account" id="account">
              Account
            </CTab>
            <CTab is={NavLink} to="/settings/installation" id="installation">
              Installation
            </CTab>
            <CTab is={NavLink} to="/settings/integrations" id="integrations">
              Integrations
            </CTab>
            <CTab is={NavLink} to="/settings/events" id="events">
              Events and properties
            </CTab>
            <CTab is={NavLink} to="/settings/team" id="team">
              Team
            </CTab>
            <CTab is={NavLink} to="/settings/subscription" id="subscription">
              Subscription
            </CTab>
            {hasFlowLocalization && (
              <CTab is={NavLink} to="/settings/localization" id="localization">
                Localization
              </CTab>
            )}
          </CTab.Bar>
        </CPage.SecondBar>
        <CPage.Container>
          <Switch>
            <Route path="/settings/account" component={AccountPage} />
            <Route path="/settings/installation" component={Installation} />
            <Route path="/settings/integrations" component={IntegrationsPage} />
            <Route path="/settings/events" component={PropertiesAndEvents} />
            <Route path="/settings/team" component={Team} />
            <Route path="/settings/subscription" component={Subscription} />
            {hasFlowLocalization && (
              <Route path="/settings/localization" component={Localization} />
            )}
            <Redirect from="/settings/install" to="/settings/installation" />
            <Redirect exact from="/settings" to="/settings/account" />
          </Switch>
        </CPage.Container>
      </IndexPage>
    );
  }
}

const mapStateToProps = state => ({
  hasFlowLocalization: selectAccountFeature(state, FLOW_LOCALIZATION)
});

const mapDispatchToProps = {
  logoutUserFromChromeExtension
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
